// NPM Imports

// Helpers

// Internal imports
import MobileNav from "./MobileNav";
import MobileFilters from "./MobileFilters";
import Filters from "./Filters";
import BackToTop from "./BackToTop";
import SiteSearch from "./SiteSearch";
import SiteSearchPlaceholder from "./SiteSearchPlaceholder";
import Accordion from '@kukidigital/kuki-accordion';
import SmoothScroll from '@kukidigital/kuki-smooth-scroll/src/Smooth-Scroll';

/**
 * Main App module used in index.js to initialise all other modules, includes helper
 * functions/modules for use in initialising modules depending on various criteria
 *
 * @returns {{init: init}}
 */
const app               = (() => {
	const loadedModules = {};

	const alwaysInit = (Module, name = false, options = false) => {
		if (name) {
			loadedModules[name] = Module;
		}
		Module.init( options );
	};

	const initialiseIfPartialInPage = (
	partial,
	Module,
	name                            = false,
	options                         = false
  ) => {
		if (window.partialsUsed.includes( partial )) {
			Module.init( options );
			if (name) {
				loadedModules[name] = Module;
			}
		}
	};

	const initialiseIfClassInPage = ( classInPage, Module ) => {
		if (document.getElementsByClassName( classInPage ).length > 0) {
			Module.init()
		}
	}

	/**
	 * @param Module {Object}
	 * @param Module.init {Function}
	 * @param name {string|boolean}
	 * @param options {Object}
	 *
	 * Detects preferred reduce motion before initiating the module
	 */
	const initialiseIfAnimationAllowed = (
	Module,
	name                               = false,
	options                            = false
  ) => {
		if ( ! window.matchMedia( "(prefers-reduced-motion: reduce)" ).matches) {
			Module.init( options );
			if (name) {
				loadedModules[name] = Module;
			}
		}
	};

	/**
	 * @param Module {Object}
	 * @param Module.init {Function}
	 * @param name {string|boolean}
	 * @param CB {Function|Boolean}
	 * @param options {Object}
	 */
	const initialiseIfOnHomepage = (
	Module,
	name                         = false,
	CB                           = false,
	options                      = false
  ) => {
		if (window.isHomePage) {
			Module.init( options );
			if (name) {
				loadedModules[name] = Module;
			}
			if (CB !== false) {
				CB( true );
			}
		} else if (CB !== false) {
			CB( false );
		}
	};

	/**
	 * @param Module {Object}
	 * @param Module.init {Function}
	 * @param name {string|boolean}
	 * @param CB {Function|Boolean}
	 * @param options {Object}
	 */
	const initialiseIfNotOnHomepage = (
	Module,
	name                            = false,
	CB                              = false,
	options                         = false
  ) => {
		if ( ! window.isHomePage) {
			Module.init( options );
			if (name) {
				loadedModules[name] = Module;
			}
			if (CB !== false) {
				CB( true );
			}
		} else if (CB !== false) {
			CB( false );
		}
	};

	/**
	 * @param Width
	 * @param Module
	 * @param options - max or min width
	 * Detects media query is reached before initiating the module, uses resize event listener to initialise the module
	 * when this breakpoint is reached
	 */
	const initialiseInBreakpoint = ( Width, Module, options ) => {
		let media;
		if (options === 'max') {
			media = window.matchMedia( '(max-width:' + Width + 'px)' );
		} else if (options === 'min') {
			media = window.matchMedia( '(min-width:' + Width + 'px)' );
		}

		if ( ! media ) {
			return false
		}

		if ( media.matches ) {
			Module.init()
		}

		const initOnResize = () => {
			if ( media.matches ) {
				Module.init()
				window.removeEventListener( 'resize', initOnResize )
			}
		}
		window.addEventListener( 'resize', initOnResize )

		return true
	}

	const initialiseIfTemplateEquals = (
	template,
	Module,
	name                             = false,
	options                          = false
  ) => {
		if (window.pageTemplate === template) {
			Module.init( options );
			if (name) {
				loadedModules[name] = Module;
			}
		}
	};

	const getLoadedModules = () => loadedModules;
	const getLoadedModule  = moduleName => {
		if (typeof loadedModules[moduleName] !== "undefined") {
			return loadedModules[moduleName];
		}

		return false;
	};

	const init = () => {
		// Always init
		alwaysInit( BackToTop );
		alwaysInit( SiteSearch );
		alwaysInit( SiteSearchPlaceholder );
		alwaysInit( Filters );
		alwaysInit(
			Accordion,
			false,
			{
				accordionClass: 'accordion__item',
				accordionTrigger: 'accordion__button',
				accordionContentClass: 'panel',
				activeClass: 'accordion__item--active',
				easingOption: 'ease-in-out',
				duration: false,
				speed: 500
			}
		);

		alwaysInit( SmoothScroll );

		// Sometimes init
		initialiseInBreakpoint( "1200", MobileNav, "max" );
		initialiseInBreakpoint( "1200", MobileFilters, "max" );

	}

	return {
		init,
		// getLoadedModules,
		// getLoadedModule
	};
})();

export default app;
